// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"865":"2f7a033542e58e6a","982":"124830771c9cbe4c"}[chunkId] + ".css";
};